// extracted by mini-css-extract-plugin
export default {"additional":"section_additional-module___additional___d453d382","expertiseField":"section_additional-module___expertiseField___a7eebd62"};